import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import axios from 'axios'
import { BASE_URL } from '../apiConfig'

export const uploadOpsMIS = createAsyncThunk(
  'uploadOpsMIS',
  async ({ jwt_token, type, uploadType, userUploadType, requestBody }) => {
    console.log('Request Body - ', requestBody)
    const options = {
      method: 'POST',
      headers: {
        Authorization: 'Bearer ' + jwt_token,
        'Content-Type': 'application/json' // Set content type to JSON
      },
      body: JSON.stringify({ mis_ops_json: requestBody }) // Wrap requestBody as needed
    }

    try {
      const response = await fetch(
        // `${BASE_URL}mis/ops/upload/?type=${type}`,
        `${BASE_URL}mis/ops/upload/?type=${type}&uploadType=${uploadType}&userUploadType=${userUploadType}`,
        options
      )
      console.log('Request Options - ', options)
      console.log('REsponse -- ', response)
      return response.json() // Assuming the response is JSON
    } catch (error) {
      console.log('Error', error)
      alert(error.message)
      throw error
    }
  }
)

export const uploadExpectedCollectionDue = createAsyncThunk(
  'uploadExpectedCollectionDue',
  async ({ jwt_token, type, file }, { rejectWithValue }) => {
    try {
      const formData = new FormData()
      formData.append('file', file)

      const response = await fetch(
        `${BASE_URL}mis/ops/upload/v2/?type=${type}`,
        {
          method: 'POST',
          headers: {
            Authorization: `Bearer ${jwt_token}`
            // Note: Don't set Content-Type manually. Let the browser set it.
          },
          body: formData
        }
      )

      const result = await response.json()

      if (!response.ok) {
        return rejectWithValue(result)
      }

      return result
    } catch (error) {
      return rejectWithValue({ message: error.message || 'Upload failed' })
    }
  }
)

const uploadOpsMISSlice = createSlice({
  name: 'uploadOpsMIS',
  initialState: {
    isLoading: false,
    data: null,
    isError: false,
    errorMessage: null
  },
  reducers: {},
  extraReducers: builder => {
    builder.addCase(uploadOpsMIS.pending, state => {
      state.isLoading = true
      state.isError = false
      state.errorMessage = null
    })
    builder.addCase(uploadOpsMIS.fulfilled, (state, action) => {
      state.isLoading = false
      state.data = action.payload
      state.isError = false
      state.errorMessage = null
    })
    builder.addCase(uploadOpsMIS.rejected, (state, action) => {
      state.isLoading = false
      state.isError = true
      state.errorMessage = action.error.message
    })
  }
})

export default uploadOpsMISSlice.reducer
